//import { UserOutlined } from '@ant-design/icons';
import { useLazyQuery } from '@apollo/client';
import { useLingui } from '@lingui/react';
import { Form, notification } from 'antd';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { GQL_LOGIN } from '~/gql/auth/auth';
import { Payload, useAuth } from '~/helpers/store/auth';
//import useTranslations from '~/helpers/store/locale/translation';
import { Role, routingDefault } from '~/pages/utils/router';
//import { classic } from '~/themes';
import { parseJwt } from '~/utils/jwt';
// import { SH2, SLink } from '~/utils/ui/utils';
// import LoginSSO from './LoginSSO';
import { WrapperItem } from '~/components/ui/wrapper-item';
import iconTrain from '@assets/images/icon/icon-train.png';
import Button from '~/components/ui/button';
import ButtonText from '~/components/ui/button-text';
import { SFormItem, SInput, SSpan } from '~/components/styles/styles';
import useGameStore from '~/helpers/store/game/game';
//import { classic } from '~/themes';

function Login() {
  const { setAvatarFileName } = useGameStore();
  const [username, setUsername] = useState('');
  const { setPayload } = useAuth();
  const navigate = useNavigate();
  const { i18n } = useLingui();
  const [form] = Form.useForm();

  //const { changeLanguage } = useTranslations();

  // const handleLanguageChange = (newLocale: string) => {
  //   changeLanguage(newLocale);
  // };

  const [login] = useLazyQuery(GQL_LOGIN, {
    onCompleted: (data) => {
      if (data.login.__typename === 'AuthReponse') {
        const dataJwt = parseJwt(data.login.tokens.access_token);
        if (!dataJwt) {
          notification.error({
            message: i18n._('common.login'),
            description: i18n._('impossible.read.token'),
            placement: 'bottomLeft',
          });
          return;
        }
        const payload: Payload = {
          access_token: data.login.tokens.access_token,
          refresh_token: data.login.tokens.refresh_token,
          ...dataJwt,
        };
        // test
        // notification.success({
        //   message: 'Notification personnalisée',
        //   description: 'Ceci est une notification avec un style custom.',
        //   className: 'global-notification-style',
        //   placement: 'bottomLeft',
        //   duration: 0,
        // });
        setPayload(payload);
        if (data) {
          setAvatarFileName(data.login.user.avatar?.fileName);
        }

        routingDefault(payload.roles as Role, navigate);
      } else {
        form.setFields([
          {
            name: 'username',
            errors: ['Ce pseudo est inconnu'],
          },
        ]);
        notification.error({
          message: i18n._('common.login'),
          description: i18n._('connection.failed'),
          placement: 'bottomLeft',
        });
      }
    },
    onError: () => {
      notification.error({
        message: i18n._('common.login'),
        description: i18n._('bad.server-login.message'),
        placement: 'bottomLeft',
      });
    },
  });

  const loginHandler = async () => {
    await login({ variables: { username } });
  };

  //if (loading) return <p>{i18n._('common.loading')} ...</p>;

  return (
    <WrapperItem
      widthLandscape="auto"
      autoWidthLandscape
      iconSrc={iconTrain}
      title={`${i18n._('common.action.login')}`}
    >
      <SFormLogin
        form={form}
        onFinish={loginHandler}
        initialValues={{ remember: true }}
      >
        <SFormItem
          name="username"
          className="customInput"
          rules={[
            {
              required: true,
              message: i18n._('input.username.message'),
            },
          ]}
        >
          <SInput
            placeholder={i18n._('common.username')}
            onChange={(e) => setUsername(e.target.value)}
            size="large"
          />
        </SFormItem>

        <SFormItem>
          <Button color="primary" type="submit" margin="20px 0 0 0">
            {i18n._('common.login')}
          </Button>
        </SFormItem>

        <SSpan>{i18n._('common.or')}</SSpan>

        <SFormItem>
          <ButtonText
            color="secondary"
            type="button"
            underlined
            onClick={() => navigate('/create-account')}
          >
            {i18n._('common.action.create.account')}
          </ButtonText>
        </SFormItem>
      </SFormLogin>
    </WrapperItem>
  );
}

/* <Form.Item>
            <SH2 $color={classic.token?.colorPrimary}>
              {i18n._('common.login')}
            </SH2>
          </Form.Item> */

/* <SLink
            $color="#9291a5"
            $textdecoration="underline"
            onClick={() => navigate('/reset-password')}
            $margin="0"
          >
            {i18n._('password.forgot')}
          </SLink>

          <LanguageSelectDiv>
            <SButton onClick={() => handleLanguageChange('en')}>
              {i18n._('common.english')}
            </SButton>
            <SButton onClick={() => handleLanguageChange('fr')}>
              {i18n._('common.french')}
            </SButton>
          </LanguageSelectDiv>
          <LoginSSO /> */
//  // prefix={<UserOutlined className="site-form-item-icon" />}
export default Login;

export const SFormLogin = styled(Form)`
  min-width: 30vw;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 15px;

  & .customInput {
    width: 80%;

    /* & span:nth-child(1),
    & input {
      background-color: rgba(240, 237, 255, 0.8);
    } */
  }

  @media (max-width: 992px) {
    & .customInput {
      width: 100%;
    }
  }
`;

export const LoginForm = styled.div`
  justify-content: center;
  align-items: center;
  width: 60%;
  @media (max-width: 992px) {
    height: auto;
    width: 95%;
  }
`;

export const SForm = styled(Form)`
  min-width: 30vw;
  height: 100%;
  padding: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 15px;

  & .customInput {
    width: 80%;

    & span:nth-child(1),
    & input {
      background-color: rgba(240, 237, 255, 0.8);
    }
  }

  @media (max-width: 992px) {
    & .customInput {
      width: 100%;
    }
  }
`;

// const LanguageSelectDiv = styled.div`
//   width: 100%;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   & button {
//     margin: 5% 2%;
//   }
// `;

export const SButton = styled.button`
  border-radius: 8px;
  border: 1px solid transparent;
  padding: 0.6em 1.2em;
  font-size: 1em;
  font-weight: 500;
  font-family: inherit;
  background-color: #1a1a1a;
  cursor: pointer;
  transition: border-color 0.25s;
  &:hover {
    border-color: #646cff;
  }
  &:focus,
  &:focus-visible {
    outline: 4px auto -webkit-focus-ring-color;
  }
`;

/*
 return (
    <LoginForm>
      <SForm onFinish={loginHandler} initialValues={{ remember: true }}>
        <Form.Item>
          <SH2 $color={classic.token?.colorPrimary}>
            {i18n._('common.login')}
          </SH2>
        </Form.Item>

        <Form.Item
          name="username"
          className="customInput"
          rules={[
            {
              required: true,
              message: i18n._('input.email.message'),
            },
          ]}
        >
          <Input
            prefix={<UserOutlined className="site-form-item-icon" />}
            placeholder={i18n._('common.username')}
            onChange={(e) => setUsername(e.target.value)}
          />
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            className="login-form-button"
          >
            {i18n._('common.login')}
          </Button>
        </Form.Item>

        <SLink
          $color="#9291a5"
          $textdecoration="underline"
          onClick={() => navigate('/reset-password')}
          $margin="0"
        >
          {i18n._('password.forgot')}
        </SLink>

        <LanguageSelectDiv>
          <SButton onClick={() => handleLanguageChange('en')}>
            {i18n._('common.english')}
          </SButton>
          <SButton onClick={() => handleLanguageChange('fr')}>
            {i18n._('common.french')}
          </SButton>
        </LanguageSelectDiv>
        <LoginSSO />
      </SForm>
    </LoginForm>
  );
*/
